import React from 'react'
import tw from 'tailwind-styled-components'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {IconButton} from '../buttons'
import {Icon} from '../icon'

export interface NotificationProps {
  title: string
  content?: React.ReactNode
  buttons?: React.ReactNode
  icon?: TablerIcons
  onClose?: () => void
}

export const Notification = (props: NotificationProps) => {
  const {title, content, icon, buttons, onClose} = props
  return (
    <TwCnt>
      <div>{icon && <Icon color="primary" icon={icon} size={24} />}</div>
      <div className="flex-1">
        <div className="font-semibold">{title}</div>
        <div className="mt-4">{content}</div>
        <div className="flex gap-12 mt-8">{buttons}</div>
      </div>
      <div>
        <IconButton
          icon="IconX"
          onClick={onClose}
          color="secondary"
          size="small"
        />
      </div>
    </TwCnt>
  )
}

const TwCnt = tw.div`
  p-16
  flex
  min-w-380
  max-w-458
  gap-16
  bg-grey-l80
  border-1
  border-solid
  border-grey-l60
  rounded-4
  shadow-lg
  plain-text-regular
`
